import { Controller } from "@hotwired/stimulus"

// メディアページ表示時のトラッキングコントローラ
//
// ページの <main> やコンテナ要素にアタッチし、
// connect 時に page_view を dataLayer に push する。
// 記事詳細ページでは article_view も push する。
export default class extends Controller {
  static values = {
    pageType: String,
    articleId: String,
    articleTitle: String,
    articleType: String,
    articleSlug: String,
    companyId: String,
    companyName: String
  }

  connect() {
    this.#trackPageView()

    if (this.pageTypeValue === "media_article_detail") {
      this.#trackArticleView()
    }
  }

  // --- private ---

  #trackPageView() {
    this.#push({
      event: "page_view",
      page_path: window.location.pathname,
      page_title: document.title,
      page_type: this.pageTypeValue,
      content_group: "media"
    })
  }

  #trackArticleView() {
    this.#push({
      event: "article_view",
      article_id: this.articleIdValue,
      article_title: this.articleTitleValue,
      article_type: this.articleTypeValue,
      article_slug: this.articleSlugValue,
      company_id: this.companyIdValue,
      company_name: this.companyNameValue
    })
  }

  #push(data) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(data)
  }
}
